import '.f3{border-left:4px solid var(--gray-200);}.ssr-plugin'
import '.f4{padding-left:1.5rem;}.ssr-plugin'
import '.f5{margin:1rem 0;}.ssr-plugin'
import '.f6{color:var(--gray-700);}.ssr-plugin'
import '.f7{font-style:italic;}.ssr-plugin'
import { Style, styled } from 'inlines'
import { PropsWithChildren } from 'react'

interface BlockQuoteProps extends PropsWithChildren {
  style?: Style
}

export const BlockQuote = ({ children, style }: BlockQuoteProps) => {
  return (
    <styled.blockquote className="f3 f4 f5 f6 f7"
      style={{
        ...style,
      }}
    >
      {children}
    </styled.blockquote>
  )
}
